export default "__VITE_ASSET__LRyMb$5l2u8gsJGdDClSMQ__"